(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/shared-components/faq-list.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/shared-components/faq-list.js');
'use strict';

const {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const FaqList = _ref => {
  let {
    faqList
  } = _ref;
  const [expanded, setExpanded] = React.useState('');
  const handleChange = item => (e, isExpanded) => {
    setExpanded(isExpanded ? item : false);
  };
  return React.createElement(Accordion, {
    customer: "tur"
  }, faqList && faqList.length > 0 && faqList.map(item => React.createElement(AccordionItem, {
    isExpanded: expanded === item.id,
    key: item.id,
    onChange: handleChange(item.id)
  }, React.createElement(AccordionSummary, null, React.createElement("h3", null, item.title)), React.createElement(AccordionDetails, null, React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: item.properties.cnt_answer
    }
  })))));
};


svs.termsIntegrity.sharedComponents.FaqList = FaqList;

 })(window);